import React from 'react';
import PropTypes from 'prop-types';
import CustomMenu from '../../../Components/CustomMenu';
import BranchSelectionWidget from '../../../Components/Sidebar/BranchSelectionWidget';

const BranchesMenu = function BranchesMenu({
  anchor = null,
  onClose = () => {},
  onClickBranch = () => {},
  branches = [PropTypes.array],
}) {
  return (
    <CustomMenu
      beforePosition="left"
      anchor={anchor}
      open={Boolean(anchor)}
      close={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <BranchSelectionWidget
        closeMenu={onClose}
        onClick={onClickBranch}
        branches={branches}
      />
    </CustomMenu>
  );
};

BranchesMenu.propTypes = {
  anchor: PropTypes.object,
  onClose: PropTypes.func,
  onClickBranch: PropTypes.func,
  branches: PropTypes.array,
};
export default BranchesMenu;
